import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyStartDocumentation from "./component";
import { withRouter } from "react-router-dom";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse
    }
}) => ({
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyStartDocumentation));
